import { useAppDispatch } from "hooks/hooks";
import SearchPopover from "./SearchPopover";
import { useRef } from "react";
import AddCarnetsButton from "./AddCarnetsButton";
import { useNavigate } from "react-router-dom";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import Popover from "components/Popover/Popover";
import InfoTooltip from "components/Popup/InfoTooltip";
import { IGetCarnetEmployeesRequestParams }
  from "Dashboard/scenes/Carnets/domain/IGetCarnetEmployeesRequestParams";
import {
  FormatDateIso,
  getFristDateOfCurrnetMonth,
  getLastDateOfCurrnetMonth
} from "utils/dateUtils";
import { useForm } from "react-hook-form";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import {
  getCarnetEmployees,
  selectState,
  setSearchModalOpen
} from "../main.slice";
import { usePagePrint } from "hooks/usePagePrint";

const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const componentRef = useRef<HTMLDivElement>(null);

  const { searchModalOpen } = useSelector(selectState);

  const searchDefaultValues: IGetCarnetEmployeesRequestParams = {
    carnetDataFrom: FormatDateIso(getFristDateOfCurrnetMonth()),
    carnetDataTo: FormatDateIso(getLastDateOfCurrnetMonth()),
    nameKey: "",
  };

  const {
    register: searchRegister,
    handleSubmit: searchHandleSubmit,
    reset: searchReset,
    setFocus: searchSetFocus,
    getValues: searchGetValues
  } = useForm<IGetCarnetEmployeesRequestParams>({
    defaultValues: searchDefaultValues,
  });

  const isSearchFormEmpty
    = isEqual(searchGetValues(), searchDefaultValues);

  const resetSearch = () => {
    dispatch(getCarnetEmployees(searchDefaultValues));
    searchReset(searchDefaultValues);
  };

  const handlePrint = usePagePrint(componentRef);

  return (
    <>
      <nav className="container">
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            toolbox={true}
            tooltip="Glavni meni"
            onClick={() => navigate('/dashboard')}
          />
        </div>
        <div>
          <ToolboxButton
            tooltip="Traži"
            toolbox={true}
            icon={ToolboxButtonIcon.Search}
            onClick={() => dispatch(setSearchModalOpen(true))}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => resetSearch()}
            />)}

          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            tooltip="Štampa"
            toolbox={true}
            onClick={() => {
              handlePrint && handlePrint();
            }}
          />
        </div>
        <InfoTooltip tooltip="Unos karneta" classesProp="carnet-toolbox-last-button">
          <AddCarnetsButton />
        </InfoTooltip>
      </nav>
      <Popover
        isOpen={searchModalOpen}
        onClose={() => dispatch(setSearchModalOpen(false))}
        title="Pretraga"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 185 }}
      >
        <SearchPopover
          register={searchRegister}
          handleSubmit={searchHandleSubmit}
          reset={searchReset}
          setFocus={searchSetFocus}
          defaultValues={searchDefaultValues} />
      </Popover>
    </>
  );
};

export default Toolbox;
